var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"512","height":"512","rx":"15%","fill":"#0077b5","key":0}),React.createElement("circle",{"cx":"142","cy":"138","r":"37","key":1}),React.createElement("path",{"stroke":"#fff","strokeWidth":"66","d":"M244 194v198M142 194v198","key":2}),React.createElement("path",{"d":"M276 282c0-20 13-40 36-40 24 0 33 18 33 45v105h66V279c0-61-32-89-76-89-34 0-51 19-59 32","key":3})]);
}

Linkedin.defaultProps = {"aria-label":"LinkedIn","role":"img","viewBox":"0 0 512 512","fill":"#fff"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
